import React from 'react';
import Tooltip from '@lwt-helix/tooltip';
import { getCurrencyFormat } from '../helpers/dataFormatters';
import PropTypes from 'prop-types';

export const AgentMovementIndicator = ({ label, value, isCurrency, tooltip }) => {
    const formattedValue = isCurrency ? getCurrencyFormat(value) : value;
    const className = `agent-movement-indicator p-3 ${isCurrency ? 'currency-value' : ''}`;
    const tooltipId = `agent-movement-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

    return (
        <div className={className}>
            {tooltip && (
                <Tooltip target={tooltipId} placement="top">
                    <span className='helix-small'>{tooltip}</span>
                </Tooltip>
            )}
            <div className="helix-display-x-small">{formattedValue}</div>
            <div id={tooltipId} className="helix-body">{label}</div>
        </div>
    );
};

AgentMovementIndicator.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    isCurrency: PropTypes.bool,
    tooltip: PropTypes.string.isRequired
};
